import { APP_PERMISSIONS } from '@exam-management/permissions';
import {
  QSetQuestionDetailsNavigator,
  QSetQuestionDetailsList,
} from '@exam-management/qset-question-details-list';
import { Box, Flex } from '@shared/components';
import { PermissionGuard } from '@shared/permissions';

export default function QSetDetailsPage() {
  return (
    <PermissionGuard requiredPermission={[APP_PERMISSIONS.EXAM.QSET.VIEW]}>
      <Flex sx={{ flexDirection: 'column', height: '100%' }}>
        <Box sx={{ p: (theme) => theme.spacing(6), flex: 1 }}>
          <QSetQuestionDetailsList />
        </Box>
        <Box sx={{ bottom: 0, position: 'sticky' }}>
          <QSetQuestionDetailsNavigator />
        </Box>
      </Flex>
    </PermissionGuard>
  );
}
